import clsx from 'clsx';
import { Anchor } from 'components/atoms';
import React from 'react';
import { useTranslation } from 'utils/hooks';


import css from './PlusTeaser.module.scss';

interface PlusRowProps 
{
  text?: React.ReactNode;
}

const PlusRow: React.FC<PlusRowProps> = ({ text }) =>
{
  const { r, t } = useTranslation('profiles');

  return (
      <div className={clsx(css.content, css.row)}>
        {text ? text : t('profiles:plusTeaser.plusRow.inhalt')}
        {r('profiles:plusTeaser.plusRow.verfügbar')}
        <div className={css.actionButtons}>
          <Anchor
            onClick={() => document.getElementById('plus-inhalte')?.scrollIntoView({ behavior: 'smooth' })}> {t('profiles:plusTeaser.moreInformations')}</Anchor>
        </div>
      </div>
  );
};

export default PlusRow;
